// You can write more code here

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
import { TransitionBase } from '@scarybeasties/phaser-framework-core/derived-classes';
/* END-USER-IMPORTS */

export default class TransitionEffectCover extends TransitionBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 960, y ?? 384);

    // transitionCover
    const transitionCover = scene.add.image(0, 0, "common", "bg-transition.jpg");
    this.add(transitionCover);

    // taz
    const taz = scene.add.sprite(-5, 55, "common", "taz-spin-01.png");
    this.add(taz);

    this.transitionCover = transitionCover;
    this.taz = taz;

    /* START-USER-CTR-CODE */
    this.taz.play("loading");
    this.taz.alpha = 0;
    /* END-USER-CTR-CODE */
  }

  private transitionCover: Phaser.GameObjects.Image;
  private taz: Phaser.GameObjects.Sprite;

  /* START-USER-CODE */

  protected spinnerTween: Phaser.Tweens.Tween | undefined;

  private coveredCallback: (() => void) | undefined;
  private doneCallback: (() => void) | undefined;

  public activate(coveredCallback?: () => void, doneCallback?: () => void) {
    if (coveredCallback) this.coveredCallback = coveredCallback;
    if (doneCallback) this.doneCallback = doneCallback;

    this.transitionIn();
    this.scene.time.delayedCall(1000, this.transitionOut, [], this);
    if (this.doneCallback) this.scene.time.delayedCall(500, this.doneCallback);
  }

  public override show(onComplete?: (() => void) | undefined): void {
    this.transitionReset();
    this.transitionIn(onComplete);
  }

  public override hide(onComplete?: () => void) {
    this.transitionOut(onComplete);
  }

  protected transitionInInit() {
    this.transitionCover.scale = 1;
    this.transitionCover.alpha = 0;

  }

  protected transitionIn(onComplete?: () => void) {
    this.scene.add.tween({
      targets: this.transitionCover,
      alpha: { from: 0, to: 1 },
      duration: 500,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      onComplete: onComplete
    });
    this.scene.add.tween({
      targets: this.taz,
      alpha: { from: 0, to: 1 },
      duration: 500,
      ease: Phaser.Math.Easing.Quadratic.InOut
    });
  }

  protected transitionOut(onComplete?: () => void) {
    this.coveredCallback?.();

    this.scene.add.tween({
      targets: this.transitionCover,
      alpha: { from: 1, to: 0 },
      duration: 500,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      onComplete: onComplete
    });

    this.scene.add.tween({
      targets: this.taz,
      alpha: { from: 1, to: 0 },
      duration: 500,
      ease: Phaser.Math.Easing.Quadratic.InOut
    });

    if (this.spinnerTween) {
      this.spinnerTween.stop();
      this.spinnerTween = undefined;
    }
  }

  protected transitionReset(): void {
    this.transitionInInit();
  }

  protected startTransitionIdle(): void {}
  protected stopTransitionIdle(): void {}

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
